var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-image-viewer d-flex"},[_c('v-img',{staticClass:"c-image",attrs:{"src":_vm.src,"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }